import React from "react";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { Skeleton } from "primereact/skeleton";
import { Tooltip } from 'primereact/tooltip';

export function MainButton({
  label,
  icon,
  iconPos,
  onClick,
  width,
  onCenter,
  onRight,
  secondary,
  isSuccess,
  isDanger,
  isUnderline,
  textOnly,
  disabled,
  extraClass,
  btnGray,
  isLoading,
  outerClass = "",
}) {
  return (
    <div
      className={`relative btn-container ${width ? width : "w-max"} ${onCenter ? "m-auto" : onRight ? "ml-auto" : ""
        } ${outerClass}`}
    >
      {isLoading ? <Skeleton width="10rem" height="2rem" /> :
        <Button
          label={label}
          onClick={onClick}
          icon={icon}
          iconPos={iconPos ? iconPos : "left"}
          className={`${secondary
            ? "btn-secondary"
            : isSuccess
              ? "btn-success"
              : isDanger
                ? "btn-danger"
                : isUnderline
                  ? "btn-underline"
                  : textOnly
                    ? "btn-text"
                    : btnGray
                      ? "btn-gray"
                      : "btn-primary"
            } w-full main-btn ${extraClass}`}
          disabled={disabled}
        />}
    </div>
  );
}

export function TabButton({
  label,
  icon = "pi pi-ellipsis-v",
  onClick,
  width,
  iconAction,
  disabled,
  isActive,
  id,
  isLoading
}) {
  return (
    <div
      className={`relative flex align-items-center justify-content-between btn-container ${width ? width : "max-w-max min-w-max"
        }  ${isActive
          ? "border-bottom-2 border-noround border-primary text-gray-900 active-tab"
          : ""
        }`}
    >
      {isLoading ? (
        <Skeleton width="10rem" height="2rem" />
      ) : (
        <>
          <Button
            label={label}
            onClick={onClick}
            className={`w-full border-none bg-transparent text-overflow-ellipsis ${isActive ? "text-color" : "text-gray-500"
              }`}
            disabled={disabled}
          />
          {iconAction && isActive && (
            <div className="tab-menu-icon ml-2">
              <i
                className={`${icon} ${isActive ? "text-gray-700" : "text-dark-900"
                  } cursor-pointer hover:text-primary transition-colors transition-duration-150`}
                onClick={(e) => {
                  e.stopPropagation();
                  iconAction(e, id);
                }}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export const ToggleButton = ({ checked, onChange, id, dual, disabled, tooltipMessage }) => {
  return (
    <div className={`toggle-btn-container ${dual ? "toggle-dual" : ""}`}>
      {disabled && tooltipMessage && (
        <Tooltip target={`#${id}`} content={tooltipMessage} position="top" />
      )}
      <input
        type="checkbox"
        id={id}
        className="toggle-checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        data-pr-tooltip={tooltipMessage}
      />
      <label htmlFor={id} className="toggle-label">
        <span className="toggle-switch"></span>
      </label>
    </div>
  );
};

